import { createRoot } from 'react-dom/client';
import { MantineProvider, createTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';

import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';

import SupportApp from './SupportApp';
import SupportBubble from './SupportBubble';
import ServiceOnlyApp from './ServiceOnlyApp';

const theme = createTheme({
    primaryColor: 'red',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
});

const container = document.getElementById('ast-support-root');
if (container) {
    const mode = container.dataset.mode || 'full';
    const position = container.dataset.position || 'br';
    const root = createRoot(container);

    let Component;
    if (mode === 'bubble') Component = SupportBubble;
    else if (mode === 'service') Component = ServiceOnlyApp;
    else Component = SupportApp;

    root.render(
        <MantineProvider theme={theme} defaultColorScheme="auto">
            <Notifications position="top-right" />
            <Component position={position} />
        </MantineProvider>
    );
}
